export default __webpack_public_path__ + "static/media/paint.5d054df4.png";